import { createSlice } from "@reduxjs/toolkit";
import { createVirtualCard, fetchCardTransactions, freezeVirtualCard, fundVirtualCard, getCardsByID, getCardsByUser, unFreezeVirtualCard, withdrawFromVirtualCard, } from "./cardActions";

const initialState = {
  isLoading: false,
  loading: false,
  cards: [],
  card: {},
  transactions: [],
  transactionsTotal: 0,
};

const cardSlice = createSlice({
  name: "cards",
  initialState, 
  reducers: {
    clearCards: (state) => {
        state.cards = [];
      },
  },
  extraReducers: {
    // ========================== EXTRA RERDUCER HANDLING GET ALL CARDS BY USER
    [getCardsByUser.pending]: (state, { payload }) => {
      state.isLoading = true;
    },
    [getCardsByUser.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
        // i want to pick only 3 items from the array
      const cards = payload.data.slice(0, 3);
      state.cards = cards;
    },
    [getCardsByUser.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.cards = [];
    },

      // ========================== EXTRA RERDUCER HANDLING GET CARD BY ID
      [getCardsByID.pending]: (state, { payload }) => {
        state.loading = true;
      },
      [getCardsByID.fulfilled]: (state, { payload }) => {
        state.loading = false;
        state.card = payload.data.data;
      },
      [getCardsByID.rejected]: (state, { payload }) => {
        state.loading = false;
      },

    // ========================== EXTRA RERDUCER HANDLING CREATING VIRTUAL CARDS
    [createVirtualCard.pending]: (state, { payload }) => {
        state.loading = true;
      },
      [createVirtualCard.fulfilled]: (state, { payload }) => {
        state.loading = false;
      },
      [createVirtualCard.rejected]: (state, { payload }) => {
        state.loading = false;
      },

    // ========================== EXTRA RERDUCER HANDLING FUND CARD
    [fundVirtualCard.pending]: (state, { payload }) => {
        state.loading = true;
      },
      [fundVirtualCard.fulfilled]: (state, { payload }) => {
        state.loading = false;
      },
      [fundVirtualCard.rejected]: (state, { payload }) => {
        state.loading = false;
      },

       // ========================== EXTRA RERDUCER HANDLING WITHDRAW FROM CARD
    [withdrawFromVirtualCard.pending]: (state, { payload }) => {
        state.loading = true;
      },
      [withdrawFromVirtualCard.fulfilled]: (state, { payload }) => {
        state.loading = false;
      },
      [withdrawFromVirtualCard.rejected]: (state, { payload }) => {
        state.loading = false;
      },

           // ========================== EXTRA RERDUCER HANDLING FREEZE A CARD
    [freezeVirtualCard.pending]: (state, { payload }) => {
        state.loading = true;
      },
      [freezeVirtualCard.fulfilled]: (state, { payload }) => {
        state.loading = false;
      },
      [freezeVirtualCard.rejected]: (state, { payload }) => {
        state.loading = false;
      },

     // ========================== EXTRA RERDUCER HANDLING FOR UNFREEZING A CARD
     [unFreezeVirtualCard.pending]: (state, { payload }) => {
        state.loading = true;
      },
      [unFreezeVirtualCard.fulfilled]: (state, { payload }) => {
        state.loading = false;
      },
      [unFreezeVirtualCard.rejected]: (state, { payload }) => {
        state.loading = false;
      },

        // ========================== EXTRA RERDUCER HANDLING FOR FETCH CARD TRANSACTIONS
     [fetchCardTransactions.pending]: (state, { payload }) => {
        state.loading = true;
      },
      [fetchCardTransactions.fulfilled]: (state, { payload }) => {
        state.loading = false;
        state.transactions = payload.data.data;
        state.transactionsTotal = payload.data.meta.total;
      },
      [fetchCardTransactions.rejected]: (state, { payload }) => {
        state.loading = false;
      },

  

  },
});

export default cardSlice.reducer;
export const {clearCards} = cardSlice.actions;
